const NAMESPACE = 'network-debug'

export const NETWORK_DEBUG_TRANSLATION_KEYS = {
  title: `${NAMESPACE}-title`,
  // Available params: {count}.
  session: `${NAMESPACE}-session`,
  empty: `${NAMESPACE}-empty`,
  emptyText: `${NAMESPACE}-empty-text`,
  kindSettings: `${NAMESPACE}-kind-settings`,
  kindLoad: `${NAMESPACE}-kind-load`,
  kindRefetch: `${NAMESPACE}-kind-refetch`,
  silent: `${NAMESPACE}-silent`,
  tabRequest: `${NAMESPACE}-tab-request`,
  tabResponse: `${NAMESPACE}-tab-response`,
  tabMapped: `${NAMESPACE}-tab-mapped`,
  tabTiming: `${NAMESPACE}-tab-timing`,
  search: `${NAMESPACE}-search`,
  copy: `${NAMESPACE}-copy`,
  copied: `${NAMESPACE}-copied`,
  copyValue: `${NAMESPACE}-copy-value`,
  copyPath: `${NAMESPACE}-copy-path`,
  copyKeyValue: `${NAMESPACE}-copy-key-value`,
  download: `${NAMESPACE}-download`,
  method: `${NAMESPACE}-method`,
  url: `${NAMESPACE}-url`,
  body: `${NAMESPACE}-body`,
  headers: `${NAMESPACE}-headers`,
  storedIn: `${NAMESPACE}-stored-in`,
  source: `${NAMESPACE}-source`,
  timingWaiting: `${NAMESPACE}-timing-waiting`,
  timingDownload: `${NAMESPACE}-timing-download`,
  timingRequest: `${NAMESPACE}-timing-request`,
  timingStore: `${NAMESPACE}-timing-store`,
  // Available params: {step}.
  timingFailed: `${NAMESPACE}-timing-failed`,
  // Available params: {ms}.
  timingTotal: `${NAMESPACE}-timing-total`,
  // Available params: {name}.
  pendingTitle: `${NAMESPACE}-pending-title`,
  // Available params: {loaded}, {total}.
  pendingProgress: `${NAMESPACE}-pending-progress`,
  pendingText: `${NAMESPACE}-pending-text`,
  // Available params: {name}, {status}.
  errorTitle: `${NAMESPACE}-error-title`,
  // Available params: {stage}, {message}.
  errorText: `${NAMESPACE}-error-text`,
  // Available params: {query}.
  noMatches: `${NAMESPACE}-no-matches`,
  noMatchesText: `${NAMESPACE}-no-matches-text`,
  // Available params: {count}, {left}.
  showMore: `${NAMESPACE}-show-more`,
  orderNewest: `${NAMESPACE}-order-newest`,
  orderOldest: `${NAMESPACE}-order-oldest`,
  orderSlowest: `${NAMESPACE}-order-slowest`,
  orderLargest: `${NAMESPACE}-order-largest`,
}
